<template>
  <div>
     <div v-if="submit_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255, 255, 255, 0.31)">
          <div class="text-xs-center">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center my-5"
                large
            ></v-progress-circular>
          </div>
      </div> 
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form
              id="createEcartBooking"
              @submit.prevent="validateBeforeSubmit('createEcartBooking')"
              data-vv-scope="createEcartBooking"
              v-model="valid"
            >
              <v-card-text>
                <v-container
                  fluid
                  grid-list-md
                  style="padding: 0px 0px 0px 0px"
                >
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Station: </label>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-autocomplete
                        label="Select Station"
                        name="Station"
                        :items="local_stations"
                        v-model="cart_booking_object.station_name"
                        return-object
                        item-text="name"
                        item-value="name"
                        v-validate="'required'"
                        :error-messages="
                          errors.collect('createEcartBooking.Station')
                        "
                        clearable
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>Details: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-textarea
                        name="details"
                        v-model="cart_booking_object.details"
                        label="E-Cart Details"
                        v-validate="'required'"
                        :error-messages="errors.collect('createEcartBooking.details')"
                        clearable
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>capacity: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="capacity"
                        v-model="cart_booking_object.capacity"
                        label="Maximum capacity"
                        v-validate="'required'"
                        :error-messages="errors.collect('createEcartBooking.capacity')"
                        clearable
                      ></v-text-field>
                      
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>fares: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="fares"
                        v-model="cart_booking_object.fares"
                        label="Fare"
                        v-validate="'required'"
                        :error-messages="errors.collect('createEcartBooking.fares')"
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout>
                   <v-layout row wrap>
                    <v-flex xs6 sm2>
                      <label>contact: </label>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        name="contact"
                        type="number"
                        v-model="cart_booking_object.contact"
                        label="Contact"
                        v-validate="'required'"
                         :error-messages="errors.collect('createEcartBooking.contact')"
                        clearable
                      ></v-text-field>
                       
                    </v-flex>
                  </v-layout>
                  
                  
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="!valid" type="submit"
                  >create
                </v-btn>
                <v-btn flat small to="/Ecart-Booking-list">Cancel</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  name: "Create",
  components: {
    VueEditor,
  },
  data: () => {
    return {
     cart_booking_object:{
       station_name:"",
       details:"",
       capacity:"",
       fares:"",
       contact:"",

     },
      local_stations:[],
      submit_loader: false,
      valid:false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
 

  methods: {
  

    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    createEcartBooking: function () {
      this.submit_loader = true;
      let new_cart_booking = Object.assign({}, this.cart_booking_object);
      new_cart_booking.station_name = this.cart_booking_object.station_name.name; 
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/v1/store-ecart-booking`,new_cart_booking,
           { headers: this.$headers }
        )
       
        .then((response) => {
          if (response.data.status == 1) {
           

            this.submit_loader = true;
            this.snackBar.show = true;
            this.snackBar.message = response.data.message;
            this.cart_booking_object = '';
            // this.$router.push({name:"Ecart-Booking-list"});  
          } else {
       
            this.snackBar.message = response.data.message;
            this.snackBar.show = true;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.submit_loader = false;
        });
    },
    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
              
                var local =  response.data.stations.local_stations;
                var metro =  response.data.stations.metro_stations;
                var mono  =  response.data.stations.mono_stations;
                var stations = local.concat(metro,mono);
                this.local_stations = stations;
      
             }  
        })
    }
  },
   mounted(){
      this.getStations();
  },
};
</script>

<style type="text/css">
  .accent--text {
    color: #f67656;
    caret-color: #383859;
}
</style>

